export default class Address {
  city = '';
  area = '';
  zipCode = '';
  address = '';
  fullAddress = '';
  originalAddress = '';

  get addressWithoutZipCode() {
    return `${this.city}${this.area}${this.address}`;
  }

  constructor({
    city = '',
    area = '',
    zipCode = '',
    address = '',
    fullAddress = '',
    originalAddress = '',
  } = {}) {
    this.city = city;
    this.area = area;
    this.zipCode = zipCode;
    this.address = address;
    this.fullAddress = fullAddress;
    this.originalAddress = originalAddress;
  }

  clone() {
    return new Address({
      city: this.city,
      area: this.area,
      zipCode: this.zipCode,
      address: this.address,
      fullAddress: this.fullAddress,
      originalAddress: this.originalAddress,
    });
  }
}
